// A file of common action buttons

import { Button } from "components/ui/button";
import { useHistory } from "react-router";
import { useIntercom } from "react-use-intercom";
import * as Routes from "routes";

export const UpgradeSubscriptionButton = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const history = useHistory();

  return (
    <Button
      variant="ghost"
      onClick={() => {
        history.push(Routes.orgManageSubscription);
      }}
    >
      {children ?? "Manage Subscription"}
    </Button>
  );
};

export const ContactSupportButton = () => {
  const { show } = useIntercom();

  return (
    <Button
      onClick={() => {
        show();
      }}
    >
      Contact Support
    </Button>
  );
};
